import Service from "../AuthService";

const tsic = {

    // TSIC
    getAllTsic(data) {
        return Service.get(`api/tsic/all`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    searchTsic(data) {
        return Service.post(`api/tsic/search`, {
            keyword: data.keyword
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    getAllTsicPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/tsic?page=${page}`,{ headers: { Authorization: `Bearer ${data.token}` } });
    },

    getTsic(data) {
        return Service.get(`/api/tsic/${data.id}`,{ headers: { Authorization: `Bearer ${data.token}` } });
    },

    createTsic(data) {
        return Service.post(`/api/tsic`,{
            tsic_code: data.code,
            activity_name_th: data.name_th,
            activity_name_en: data.name_en
        },{
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editTsic(data) {
        return Service.put(`/api/tsic/${data.id}`,{
            tsic_code: data.code,
            activity_name_th: data.name_th,
            activity_name_en: data.name_en
        },{
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteTsic(data) {
        return Service.delete(`/api/tsic/${data.id}`,{ headers: { Authorization: `Bearer ${data.token}` } });
    },


    // Industry
    getAllIndustries(data) {
      return Service.get(`/api/industries/all`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    searchIndustries(data) {
        return Service.post(`api/industries/search`, {
            keyword: data.keyword
        }, {
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    getAllIndustriesPaginate(data) {
        let page = data.page ? data.page : 1;
        return Service.get(`/api/industry?page=${page}`, { headers: { Authorization: `Bearer ${data.token}` } });
    },

    getIndustry(data) {
        return Service.get(`/api/industry/${data.id}`,{ headers: { Authorization: `Bearer ${data.token}` } });
    },

    createIndustry(data) {
        return Service.post(`/api/industry`,{
            name_th: data.name_th,
            name_en: data.name_en,
            description_th: data.description_th,
            description_en: data.description_en,
            icon: data.icon,
            status: data.status,
            industry_tsic: data.industry_tsic
        },{
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    editIndustry(data) {
        // console.log(data)
        return Service.put(`/api/industry/${data.id}`,{
            name_th: data.name_th,
            name_en: data.name_en,
            description_th: data.description_th,
            description_en: data.description_en,
            icon: data.icon,
            status: data.status,
            industry_tsic: data.industry_tsic
        },{
            headers: { Authorization: `Bearer ${data.token}` }
        });
    },

    deleteIndustry(data) {
        return Service.delete(`/api/industry/${data.id}`,{ headers: { Authorization: `Bearer ${data.token}` } });
    }

};

export default tsic;
